export const RESI_PLAN_ORDER = Object.freeze({
  'SA-CUST_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'SA-CUST_PRCH': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'SA-PROS_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'NSW-CUST_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'VIC-CUST_PRCH': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'ACT-PROS_SWT': ['Origin Go', 'Origin Flexi Usage', 'Origin Basic'],
  'WA-CUST_SWT': ['Origin Go', 'Origin Flexi Usage', 'Origin Supply'],
  'QLD-PROS_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'NSW-CUST_PRCH': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'VIC-CUST_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'NSW-PROS_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'VIC-PROS_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'ACT-CUST_SWT': ['Origin Go', 'Origin Flexi Usage', 'Origin Basic'],
  'QLD-CUST_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'WA-CUST_MOVE': ['Origin Go', 'Origin Flexi Usage', 'Origin Supply'],
  'ACT-CUST_MOVE': ['Origin Go', 'Origin Flexi Usage', 'Origin Basic'],
  'SA-CUST_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'SA-PROS_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'ACT-PROS_MOVE': ['Origin Go', 'Origin Flexi Usage', 'Origin Basic'],
  'QLD-CUST_PRCH': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'VIC-PROS_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'QLD-PROS_MOVE': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'NSW-CUST_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'WA-PROS_MOVE': ['Origin Go', 'Origin Flexi Usage', 'Origin Supply'],
  'VIC-CUST_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'WA-CUST_PRCH': ['Origin Go', 'Origin Flexi Usage', 'Origin Supply'],
  'WA-PROS_SWT': ['Origin Go', 'Origin Flexi Usage', 'Origin Supply'],
  'ACT-CUST_PRCH': ['Origin Go', 'Origin Flexi Usage', 'Origin Basic'],
  'QLD-CUST_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
  'NSW-PROS_SWT': ['Origin Go', 'Origin Flexi', 'Origin Basic'],
});

export const SME_PLAN_ORDER = Object.freeze({
  'SA-CUST_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'SA-CUST_PRCH': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'SA-PROS_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'NSW-CUST_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'VIC-CUST_PRCH': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'ACT-PROS_SWT': [
    'Origin Business Go',
    'Origin Business Flexi Usage',
    'Origin Business Solar Boost',
  ],
  'WA-CUST_SWT': ['Origin Business Go', 'Origin Business Flexi Usage', 'Origin Essentials'],
  'QLD-PROS_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'NSW-CUST_PRCH': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'VIC-CUST_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'NSW-PROS_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'VIC-PROS_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'ACT-CUST_SWT': [
    'Origin Business Go',
    'Origin Business Flexi Usage',
    'Origin Business Solar Boost',
  ],
  'QLD-CUST_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'WA-CUST_MOVE': ['Origin Business Go', 'Origin Business Flexi Usage', 'Origin Essentials'],
  'ACT-CUST_MOVE': [
    'Origin Business Go',
    'Origin Business Flexi Usage',
    'Origin Business Solar Boost',
  ],
  'SA-CUST_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'SA-PROS_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'ACT-PROS_MOVE': [
    'Origin Business Go',
    'Origin Business Flexi Usage',
    'Origin Business Solar Boost',
  ],
  'QLD-CUST_PRCH': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'VIC-PROS_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'QLD-PROS_MOVE': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'NSW-CUST_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'WA-PROS_MOVE': ['Origin Business Go', 'Origin Business Flexi Usage', 'Origin Essentials'],
  'VIC-CUST_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'WA-CUST_PRCH': ['Origin Business Go', 'Origin Business Flexi Usage', 'Origin Essentials'],
  'WA-PROS_SWT': ['Origin Business Go', 'Origin Business Flexi Usage', 'Origin Essentials'],
  'ACT-CUST_PRCH': [
    'Origin Business Go',
    'Origin Business Flexi Usage',
    'Origin Business Solar Boost',
  ],
  'QLD-CUST_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
  'NSW-PROS_SWT': ['Origin Business Go', 'Origin Business Basic', 'Origin Business Solar Boost'],
});
